var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarretright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.19492 5.86461L2.01956 10.0399C1.81818 10.2413 1.49171 10.2413 1.29035 10.0399L0.803369 9.55296C0.602339 9.35193 0.601952 9.02612 0.802509 8.82462L4.11155 5.5L0.802509 2.1754C0.601952 1.9739 0.602339 1.64809 0.803369 1.44706L1.29035 0.960073C1.49173 0.758699 1.8182 0.758699 2.01956 0.960073L6.19492 5.13539C6.39627 5.33676 6.39627 5.66324 6.19492 5.86461Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarretright);
export default __webpack_public_path__ + "static/media/carretright.a25040117e7e69cc5871b61ee825cebd.svg";
export { ForwardRef as ReactComponent };